module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/6x2-flatpack-mobile-af0e502acb54b4d88f6ec018858b07d2.png";